import {fromJS} from 'immutable'

import {
  GROUP_CHAT_SCOPES
} from '../../config/constants'

import {
  SET_GROUP_CHATS,
  SET_GROUP_CHAT,
  SET_BOOKMARKED_GROUP_CHATS,
  REMOVE_BOOKMARKED_GROUP_CHAT,
  SET_SUBSCRIBED_GROUP_CHATS,
  REMOVE_SUBSCRIBED_GROUP_CHAT,
  SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT,
  REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT,
  SET_GROUP_CHAT_ORDERS
} from '../action_types'

const bookmarkedGroupChatsReducer = (state = fromJS({list: []}), action) => {
  switch (action.type) {
    case SET_BOOKMARKED_GROUP_CHATS:
      if (!action.groups) return state

      const bookmarkedGroups = fromJS(action.groups)
        .reduce(((list, g) => list.set(g.get('key'), g)), fromJS({}))

      state = state.set('all', bookmarkedGroups)

      const list = bookmarkedGroups.toList()
        .sortBy((g) => g.get('name').toLowerCase())

      state = state.set('list', list)

      return state

    case REMOVE_BOOKMARKED_GROUP_CHAT:
      state = state.deleteIn(['all', action.key])

      const index = state.get('list', fromJS([]))
        .findIndex((g) => g.get('key') === action.key)

      state = state.deleteIn(['list', index])

      return state

    default:
      return state
  }
}
const groupChatSubscriptionsGroupsReducer = (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT:
      if (!action.users) {
        state = state.set(
          action.groupId,
          state.get(action.groupId, fromJS({})).map((s) => s.delete(action.scope))
        )
      }
      else {
        const subscriptions = fromJS(action.users)
          .map((s) => fromJS({[action.scope]: s}))

        state = state.set(
          action.groupId,
          state.get(action.groupId, fromJS({})).mergeDeep(subscriptions)
        )
      }

      return state

    case REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT:
      state = state.deleteIn([action.groupId, action.key, action.scope])

      if (state.getIn([action.groupId, action.key], fromJS({})).size === 0) {
        state = state.deleteIn([action.groupId, action.key])
      }

      return state

    default:
      return state
  }
}

const groupChatSubscriptionsUsersReducer = (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_SUBSCRIBED_GROUP_CHATS:
      if (!action.groups) {
        state = state.set(
          action.uid,
          state.get(action.uid, fromJS({})).map((s) => s.delete(action.scope))
        )
      }
      else {
        const subscriptions = fromJS(action.groups)
          .map((s) => fromJS({[action.scope]: s}))

        state = state.set(
          action.uid,
          state.get(action.uid, fromJS({})).mergeDeep(subscriptions)
        )
      }

      return state

    case REMOVE_SUBSCRIBED_GROUP_CHAT:
      state = state.deleteIn([action.uid, action.key, action.scope])

      if (state.getIn([action.uid, action.key], fromJS({})).size === 0) {
        state = state.deleteIn([action.uid, action.key])
      }

      return state

    default:
      return state
  }
}

const groupChatSubscriptionsReducer = (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_SUBSCRIBED_GROUP_CHATS:
    case REMOVE_SUBSCRIBED_GROUP_CHAT:
      state = state.set(
        'users',
        groupChatSubscriptionsUsersReducer(state.get('users'), action)
      )

      return state

    case SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT:
    case REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT:
      state = state.set(
        'groups',
        groupChatSubscriptionsGroupsReducer(state.get('groups'), action)
      )

      return state

    default:
      return state
  }
}

export default (state = fromJS({}), action) => {
  switch (action.type) {
    case SET_GROUP_CHATS:
      const {scope, groups} = action
      state = state.set(scope, fromJS(groups))

      if (scope !== GROUP_CHAT_SCOPES.DELETED) {
        state = state.set(
          'all',
          fromJS({})
            .merge(state.get(GROUP_CHAT_SCOPES.SUPER_PRIVATE))
            .merge(state.get(GROUP_CHAT_SCOPES.PRIVATE))
            .merge(state.get(GROUP_CHAT_SCOPES.GLOBAL))
        )
      }

      return state

    case SET_GROUP_CHAT:
      if (!action.groupChat) return state.deleteIn(['all', action.key])

      const {key} = action.groupChat
      state = state.setIn([action.groupChat.scope, key], fromJS(action.groupChat))
      state = state.setIn(['all', key], fromJS(action.groupChat))

      return state

    case SET_BOOKMARKED_GROUP_CHATS:
    case REMOVE_BOOKMARKED_GROUP_CHAT:
      state = state.set(
        '_bookmarks',
        bookmarkedGroupChatsReducer(state.get('_bookmarks'), action)
      )

      return state

    case SET_SUBSCRIBED_GROUP_CHATS:
    case REMOVE_SUBSCRIBED_GROUP_CHAT:
    case SET_SUBSCRIBED_USERS_FOR_GROUP_CHAT:
    case REMOVE_SUBSCRIBED_USER_FOR_GROUP_CHAT:
      state = state.set(
        '_subscriptions',
        groupChatSubscriptionsReducer(state.get('_subscriptions'), action)
      )

      return state

    case SET_GROUP_CHAT_ORDERS:
      state = state.setIn(['_orders', action.scope], fromJS(action.orders))

      return state

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/group_chats.js
 **/